import { ReactComponent as NoTransactions } from 'assets/svg/no-transactions.svg'
import { OrderTerminalButton } from 'components/Placeholders/Buttons/OrderTerminalButton.tsx/OrderTerminalButton'
import { NoInitialResults } from 'components/Placeholders/NoInitialResults'
import { NoResults } from 'components/Placeholders/NoResults'
import { component } from 'translations'

interface Props {
  hasNoInitialDeposits: boolean
}

export const DepositsEmptyState = ({ hasNoInitialDeposits }: Props) => {
  return hasNoInitialDeposits ? (
    <NoInitialResults
      icon={<NoTransactions />}
      description={component.noInitialResults.description}
      title={component.noInitialResults.titleDeposits}
    >
      <OrderTerminalButton />
    </NoInitialResults>
  ) : (
    <NoResults
      title={component.noResults.titleDeposits}
      description={component.noResults.descDeposits}
    />
  )
}
